import VpnKeyIcon from '@mui/icons-material/VpnKey';
import WarningIcon from '@mui/icons-material/Warning';
import Chip from '@mui/material/Chip';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  chip: {
    height: 20,
    fontSize: theme.typography.caption.fontSize,
    marginRight: theme.spacing(0.5),
    fontWeight: 'bold',
  },
  successChip: {
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
  },
  warningChip: {
    borderColor: theme.palette.warning.main,
    color: theme.palette.warning.main,
  },
  icon: {
    fontSize: 14,
    marginLeft: theme.spacing(0.75),
  },
  successIcon: {
    color: theme.palette.success.main,
  },
  warningIcon: {
    color: theme.palette.warning.main,
  },
  progress: {
    marginLeft: theme.spacing(0.75),
  },
}));

export interface PimStatusChipProps {
  pimEnabled?: boolean;
  pimGroupId?: string | null;
  loading: boolean;
}

/**
 * Reports whether a PIM-enabled tenant already has its PIM group provisioned.
 * Nothing is rendered for tenants that do not use PIM.
 */
export const PimStatusChip = ({
  pimEnabled,
  pimGroupId,
  loading,
}: PimStatusChipProps) => {
  const { classes, cx } = useStyles();

  if (!pimEnabled) return null;

  if (loading) {
    return (
      <Chip
        icon={<CircularProgress size={10} className={classes.progress} />}
        label="Fetching PIM status..."
        size="small"
        variant="outlined"
        className={classes.chip}
      />
    );
  }

  if (pimGroupId) {
    return (
      <Chip
        icon={<VpnKeyIcon className={cx(classes.icon, classes.successIcon)} />}
        label="PIM access will be enabled for this tenant"
        size="small"
        variant="outlined"
        className={cx(classes.chip, classes.successChip)}
      />
    );
  }

  return (
    <Chip
      icon={<WarningIcon className={cx(classes.icon, classes.warningIcon)} />}
      label="PIM access setup not yet complete for this tenant"
      size="small"
      variant="outlined"
      className={cx(classes.chip, classes.warningChip)}
    />
  );
};
